module.exports = __webpack_public_path__ + "static/img_0365-79f22a0b3e6e36e7c5bad44d120a84b7.webp";